import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import MusicPlayer from './components/MusicPlayer';
import HomePage from './pages/HomePage';
import CulturalPage from './pages/CulturalPage';
import LauraPage from './pages/LauraPage';
import ChristmasPage from './pages/ChristmasPage';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <div className="App grain">
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/eventos-culturales" element={<CulturalPage />} />
            <Route path="/laura-dickinson" element={<LauraPage />} />
            <Route path="/navidad" element={<ChristmasPage />} />
          </Routes>
          <Footer />
          <WhatsAppButton />
          <MusicPlayer />
          <Toaster />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
